<template>
    <div class="group">
        <h2>{{ label }} <span v-if="required">*</span></h2>
        <p :class="{ error }">{{ error }}</p>
        <ClientColorButton :size="'xs'" :width="'auto'" @click="updateGlobalValue();" class="buttonSelect">
            <template v-if="allOptionAreSelected">
                {{ $t("common.selectNone") }}
            </template>
            <template v-else>
                {{ $t("common.selectAll") }}
            </template>
        </ClientColorButton>
        <section>
            <div v-for="option in readonlyOptions" :key="option.value" class="checkbox checked readonly">
                <label class="cutWordM">
                    <span v-if="haveLogo" class="picture-icon"><img :src="option.logo || '../../../assets/catalog.png'"/></span> {{ option.label }}
                </label>
            </div>
            <div v-for="option in optionsUsable" :key="option.value" class="checkbox" :class="{ checked: value.includes(option.value) }">
                <label :class="{ forDisabled: option.disabled, cutWordM: true }" :for="`${name}-${option.value}`">
                    <input
                        type="checkbox"
                        v-show="!haveLogo"
                        :id="`${name}-${option.value}`"
                        :checked="value.includes(option.value)"
                        @input="e => selectValue(option.value, e)"
                        :ref="`${name}-${option.value}`"
                        :disabled="option.disabled"
                    />
                    <span v-if="haveLogo" class="picture-icon"><img :src="option.logo || '../../../assets/catalog.png'"/></span> {{ option.label }}
                </label>
            </div>
        </section>
        <ClientColorButton :size="'xs'" @click="updateGlobalValue();" class="buttonSelect">
            <template v-if="allOptionAreSelected">
                {{ $t("common.selectNone") }}
            </template>
            <template v-else>
                {{ $t("common.selectAll") }}
            </template>
        </ClientColorButton>
    </div>
</template>

<script>
import ClientColorButton from "@/components/ui/ClientColorButton";

export default {
    data: () => ({
        localErrorMessage: undefined
    }),
    props: {
        label: {
            required: true,
            type: String
        },
        value: {
            required: true
        },
        options: {
            type: Array,
            required: true
        },
        haveLogo: {
            type: Boolean,
            required: false,
            default: false
        },
        name: {
            type: String,
            required: true
        },
        required: {
            type: Boolean,
            required: false,
            default: false
        },
        errorMessage: {
            type: String,
            required: false,
            default: undefined
        }
    },
    computed: {
        error() {
            return this.errorMessage || this.localErrorMessage;
        },
        allOptionAreSelected() {
            return this.options.length === this.value.length;
        },
        readonlyOptions() {
            return this.options.filter(option => option.readonly);
        },
        optionsUsable() {
            return this.options.filter(option => !option.readonly);
        }
    },
    components: {
        ClientColorButton
    },
    methods: {
        selectValue(value, e) {
            const res = [...this.value];
            if (e.target.checked) {
                res.push(value);
            } else {
                res.splice(res.findIndex(item => item === value), 1);
            }
            this.$emit("input", res);
        },
        updateGlobalValue() {
            const options = this.allOptionAreSelected ? this.readonlyOptions : this.options;
            this.$emit("input", options.map(option => option.value));
        }
    }
};
</script>
<style lang="scss" scoped>
@import "../../../assets/css/themes";
@import "../../../assets/css/media";
h2 {
    font-size: 17px;
    text-transform: uppercase;
    font-family: "Roboto", sans-serif;
}
section {
    @include sm {
        grid-template-columns: 1fr 1fr;
        place-items: center center;
        place-content: start start;
    }
    .checkbox {
        .picture-icon {
            display: block;
            margin: 5px auto;
            width: 80px;
            height: 80px;
            cursor: pointer;
            border-radius: 50%;
            border: 2px transparent solid;
            transition: all 0.3s ease;
            padding: 5px;
            > img {
                width: 100%;
            }
        }
        label {
            text-transform: uppercase;
            font-weight: 400;
            font-family: Oswald, Sans-Serif;
            cursor: pointer;
            padding: 5px 10px;
            border-radius: 50px;
            display: block;
            text-align: left;
        }
        label.forDisabled {
            color: #bcbdbd;
        }
        text-align: center;
        &.readonly {
            label,
            .picture-icon {
                cursor: default;
            }
        }
        &.checked {
            .picture-icon {
                border-color: $color2;
            }
        }
    }
}
p.error {
    color: red;
    font-style: italic;
    font-size: 14px;
    word-break: break-word;
}
.buttonSelect {
    margin: 20px 0 20px 0;
}
</style>



// WEBPACK FOOTER //
// CheckboxGroupBloc.vue?599fbd48